import { /* DEFAULT_MEDIA_QUERY_PLATFORMS, */ COMPONENT_TYPE as TYPE } from 'common/constants';
import View from 'client/components/common/BuildingBlocks/FloatBelow/FloatBelow';
import { generateElementId, generateNodeId } from 'client/components/common/BuildingBlocks/utils/common';

export const FLOAT_BELOW = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.FLOAT_BELOW,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: FLOAT_BELOW.displayName,
					selectable: false,
					draggable: false,
					expandable: true,
					expanded: true,
				},
				nodeProps: {
					id: generateNodeId(_id, 'flb'),
				},
				componentProps: {
					styles: {},
					other: {},
				},
			},
			children: [],
		},
	};
};

FLOAT_BELOW.displayName = 'Float below';
